import { sendErrorNotification } from "@components/Notifications";
import { circulationStatsApi } from "@api/stats/circulationStats";

export const IS_LOADING = "statsTopBorrowers/IS_LOADING";
export const SUCCESS = "statsTopBorrowers/SUCCESS";
export const HAS_ERROR = "statsTopBorrowers/HAS_ERROR";

export const fetchTopBorrowers = (fromDate, toDate) => {
  return async (dispatch) => {
    dispatch({
      type: IS_LOADING,
    });

    try {
      const response = await circulationStatsApi.getTopBorrowers(
        fromDate,
        toDate
      );
      await dispatch({
        type: SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      await dispatch({
        type: HAS_ERROR,
        payload: error,
      });
      await dispatch(sendErrorNotification(error));
    }
  };
};
